<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Invitations') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Invitations allow you to invite users to join your project. Users must be registered in the app to receive invitations.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|When you invite a user, they receive a notification in their Direct Messages with the bot. They can accept or decline the invitation or you can revoke it. Invitations can be sent multiple times if needed.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Invitation Status') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                <strong>{{ s__('ProjectSettings|Pending') }}:</strong>
                {{
                  s__(
                    'ProjectSettings|Invitation has been sent and is waiting for the user to respond.'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                <strong>{{ s__('ProjectSettings|Accepted') }}:</strong>
                {{
                  s__('ProjectSettings|User has accepted the invitation and joined the project.')
                }}
              </li>
              <li style="margin-bottom: 8px">
                <strong>{{ s__('ProjectSettings|Declined') }}:</strong>
                {{ s__('ProjectSettings|User has declined the invitation.') }}
              </li>
              <li style="margin-bottom: 8px">
                <strong>{{ s__('ProjectSettings|Expired') }}:</strong>
                {{ s__('ProjectSettings|Invitation has expired and is no longer valid.') }}
              </li>
              <li style="margin-bottom: 8px">
                <strong>{{ s__('ProjectSettings|Revoked') }}:</strong>
                {{
                  s__(
                    'ProjectSettings|Invitation has been revoked by the inviter and is no longer valid.'
                  )
                }}
              </li>
            </ul>

            <h4>{{ s__('ProjectSettings|Requirements') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Users must be registered in the app to be found for invitation. To register, they can message the bot in Telegram, or sign up with email.'
                )
              }}
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
